// extracted by mini-css-extract-plugin
export default {"toggleEntry":"_3t7DX6SJOyF5l79UPY4mDL"};